import kb from '../helpers/kb';

const hsb2rgb = ({ hue, saturation, brightness, alpha }) => {
  const b = brightness * saturation;
  return kb(hue, alpha, b, Math.max(0, brightness - b));
};

export default hsb2rgb;
